import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Descriptions, Modal, Select } from 'antd';
import useNotification from '../../hooks/useNotification';
import useAxios from '../../hooks/useAxios';
import { IGetTestSubjects } from '../../models/testCenter.model';
import Loader from '../Loader';
import ErrorResponse from '../ErrorResponse';
import { getTestSubjects } from '../../api/testCenter.api';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  onCreateSubject: (req: any) => void;
}

const InputSubjectModal: FC<IProps> = ({
  visible,
  setVisible,
  onCreateSubject,
}) => {
  const { t } = useTranslation();
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetTestSubjects>();

  const [subjectCode, setSubjectCode] = useState<number | undefined>();
  const [totalPoint, setTotalPoint] = useState('');

  useEffect(() => {
    execute(getTestSubjects());
  }, []);

  const onClose = () => {
    setSubjectCode(undefined);
    setTotalPoint('');
    setVisible(false);
  };

  const onSubmit = () => {
    if (!subjectCode) {
      return infoNotification(t('cbt.type.message3'));
    }
    if (!totalPoint) {
      return infoNotification(t('cbt.type.message4'));
    }

    onCreateSubject({
      subjectCode,
      totalPoint: Number(totalPoint),
    });

    onClose();
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Modal
        title={t('cbt.type.title2')}
        visible={visible}
        onCancel={onClose}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="submit" className='btn-basic pink' onClick={onSubmit}>
              {t('common.button.save')}
            </AntButton>
            <AntButton key="cancel" className='btn-basic gray' onClick={onClose}>
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div className='comm-table__area rowType mt-0'>
          <Descriptions bordered column={1}>
            <Descriptions.Item label={t('cbt.type.column5')}>
              <div className="w-150p">
                <Select
                  className="w-100"
                  placeholder={t('common.button.select')}
                  value={subjectCode}
                  onChange={(value) => setSubjectCode(value)}
                >
                  {res?.data.map((item) => (
                    <Select.Option
                      key={item.subjectCode}
                      value={item.subjectCode}
                    >
                      {item.subjectName}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </Descriptions.Item>
            <Descriptions.Item label={t('cbt.type.column7')}>
              <div className="w-150p">
                <input
                  className="form-control"
                  type="number"
                  value={totalPoint}
                  onChange={(e) => setTotalPoint(e.target.value)}
                />
              </div>
            </Descriptions.Item>
          </Descriptions>
        </div>
      </Modal>
    </>
  );
};

export default InputSubjectModal;
